const getCategoryIds = (item) => item.dataset.caseCategories
    .split(',')
    .map((categoryId) => Number.parseInt(categoryId, 10))
    .filter(Boolean);

const getCategoryOverrides = (filters) => {
    try {
        return JSON.parse(filters.dataset.caseOverrides || '{}');
    } catch (error) {
        return {};
    }
};

const getSelectedCases = (filters) => {
    try {
        const parsed = JSON.parse(filters.dataset.selectedCases || '[]');
        return Array.isArray(parsed) ? parsed.map((id) => Number.parseInt(id, 10)).filter(Boolean) : [];
    } catch (error) {
        return [];
    }
};

const initHomeCasesFilters = () => {
    document.querySelectorAll('[data-home-cases-filters]').forEach((filters) => {
        const section = filters.closest('.home-cases-showcase');
        const grid = section?.querySelector('.home-cases-showcase__grid');
        const cards = Array.from(section?.querySelectorAll('.home-cases-showcase__item') || []);
        const controls = Array.from(filters.querySelectorAll('.home-cases-showcase__filter'));
        const categoryOverrides = getCategoryOverrides(filters);
        const selectedCases = getSelectedCases(filters);

        if (!section || !cards.length || !controls.length) {
            return;
        }

        const setActiveCategory = (categoryId) => {
            const overrideCaseIds = categoryId > 0 ? categoryOverrides[String(categoryId)] || [] : [];
            let matchingCards = [];

            if (0 === categoryId) {
                if (selectedCases.length > 0) {
                    matchingCards = selectedCases
                        .map((caseId) => cards.find((card) => Number.parseInt(card.dataset.caseId, 10) === caseId))
                        .filter(Boolean);
                } else {
                    matchingCards = cards.slice(0, 6);
                }
            } else if (overrideCaseIds.length > 0) {
                matchingCards = overrideCaseIds
                    .map((caseId) => cards.find((card) => Number.parseInt(card.dataset.caseId, 10) === Number.parseInt(caseId, 10)))
                    .filter(Boolean)
                    .slice(0, 6);
            } else {
                matchingCards = cards
                    .filter((card) => getCategoryIds(card).includes(categoryId))
                    .slice(0, 6);
            }

            section.classList.toggle('is-filtered', categoryId > 0);

            cards.forEach((card) => {
                const isMatched = matchingCards.includes(card);
                card.hidden = !isMatched;

                if (isMatched) {
                    const index = matchingCards.indexOf(card);
                    card.classList.toggle(
                        'is-home-featured',
                        0 === categoryId && index < 2
                    );
                } else {
                    card.classList.remove('is-home-featured');
                }
            });

            if (grid) {
                matchingCards.forEach((card) => {
                    grid.appendChild(card);
                });
            }

            controls.forEach((control) => {
                const controlUrl = new URL(control.href, window.location.origin);
                const controlCategoryId = Number.parseInt(controlUrl.searchParams.get('home_case_category') || '0', 10);
                const isActive = !control.hasAttribute('data-home-cases-smm') && controlCategoryId === categoryId;

                control.classList.toggle('is-active', isActive);
                control.toggleAttribute('aria-current', isActive);
            });
        };

        const activeControl = controls.find((control) => control.classList.contains('is-active')) || controls[0];
        const activeUrl = new URL(activeControl.href, window.location.origin);
        setActiveCategory(Number.parseInt(activeUrl.searchParams.get('home_case_category') || '0', 10));

        controls.forEach((control) => {
            control.addEventListener('click', (event) => {
                if (control.hasAttribute('data-home-cases-smm')) {
                    return;
                }

                event.preventDefault();

                const controlUrl = new URL(control.href, window.location.origin);
                const categoryId = Number.parseInt(controlUrl.searchParams.get('home_case_category') || '0', 10);
                const nextUrl = new URL(window.location.href);

                if (categoryId > 0) {
                    nextUrl.searchParams.set('home_case_category', String(categoryId));
                } else {
                    nextUrl.searchParams.delete('home_case_category');
                }

                window.history.replaceState({}, '', nextUrl);
                setActiveCategory(categoryId);
            });
        });
    });
};

if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', initHomeCasesFilters, { once: true });
} else {
    initHomeCasesFilters();
}

